/** @jsxImportSource @emotion/react */
import {
  EuiButton,
  EuiCallOut,
  EuiFlexGroup,
  EuiLink,
  EuiLoadingSpinner,
  EuiPageTemplate,
  EuiPanel,
  EuiSpacer,
  EuiText,
  EuiTitle,
} from "@inscopix/ideas-eui";
import { usePollPersonalSpace } from "hooks/usePollPersonalSpace";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { UserPersonalSpaceRequestStatus } from "types/constants";
import { css } from "@emotion/react";

export const PanelWelcome = () => {
  const { status } = usePollPersonalSpace();
  const routeMap = useRouteMapContext((s) => s.routeMap);

  return (
    <>
      <EuiPanel hasShadow={false} hasBorder={false}>
        {status === UserPersonalSpaceRequestStatus.PENDING && (
          <EuiCallOut
            title={
              <EuiFlexGroup alignItems="center" gutterSize="s">
                <EuiLoadingSpinner />
                <EuiText>Creating Your Personal Space</EuiText>
              </EuiFlexGroup>
            }
          >
            <EuiText>
              We are creating your personal space. This should only take a few
              minutes. This page will automatically refresh when completed.
            </EuiText>
          </EuiCallOut>
        )}

        {status !== UserPersonalSpaceRequestStatus.PENDING &&
          status !== UserPersonalSpaceRequestStatus.COMPLETED && (
            <>
              <EuiPageTemplate.EmptyPrompt
                title={<h2>Create your personal space</h2>}
                color="plain"
                layout="horizontal"
                hasShadow={false}
                hasBorder={true}
                restrictWidth={false}
                css={css`
                  text-align: left;
                  .euiEmptyPrompt__content {
                    max-inline-size: fit-content;
                  }
                `}
                grow={false}
                body={
                  <>
                    <p>
                      Get started using IDEAS with a free personal space. It
                      comes with 20GB of storage space and 5 compute credits.
                      You can upload and analyze your own data, or copy one of
                      our demo projects.
                    </p>
                    {status === UserPersonalSpaceRequestStatus.FAILED && (
                      <>
                        <EuiCallOut
                          color="warning"
                          iconType={"warning"}
                          title="Failed to Create Personal Space"
                        >
                          Your previous request to create a personal space
                          failed. You may try again below or contact support for
                          help.
                        </EuiCallOut>{" "}
                        <EuiSpacer />
                      </>
                    )}
                  </>
                }
                actions={
                  <EuiButton
                    color="primary"
                    fill
                    onClick={() => routeMap.CREATE_PERSONAL_SPACE.navigateTo()}
                  >
                    Create personal space
                  </EuiButton>
                }
                footer={
                  <>
                    <EuiTitle size="xxs">
                      <span>Want to learn more?</span>
                    </EuiTitle>{" "}
                    <EuiLink
                      href="https://inscopix.github.io/ideas-docs/"
                      target="_blank"
                    >
                      Read the docs
                    </EuiLink>
                  </>
                }
              />
            </>
          )}
      </EuiPanel>
    </>
  );
};
